import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "promotion-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PromotionCard = _resolveComponent("PromotionCard")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('home.latestNews')), 1),
      _createVNode(_component_van_swipe, {
        loop: true,
        autoplay: 3000,
        "indicator-color": "#D4AF37",
        class: "promotion-swiper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.promotionList, (promotion, index) => {
            return (_openBlock(), _createBlock(_component_van_swipe_item, {
              key: index,
              class: "swipe-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PromotionCard, { promotion: promotion }, null, 8, ["promotion"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}